export default __webpack_public_path__ + "static/media/CircledCross.b03d83c8.svg";